import { SeoLandingLayout, SeoLandingPageData } from '../../../components/SeoLandingLayout';

const data: SeoLandingPageData = {
  seo: {
    title: 'Reporting financier association : rapport CA, financeurs, subventions | Trezoone',
    description: 'Produisez facilement vos rapports financiers d\'association : rapport pour le CA, rapport d\'activité, compte rendu pour les financeurs.',
    canonical: '/reporting-financier-association',
    keywords: 'reporting financier association, rapport financier association, rapport CA association, bilan trésorerie association',
  },
  hero: {
    tag: 'Reporting financier association',
    title: 'Produire un rapport financier pour votre CA en 10 minutes, pas en 3 heures.',
    subtitle: 'Les administrateurs de votre association ont besoin de chiffres clairs, pas de tableaux complexes. Voici comment produire des rapports utiles rapidement.',
    ctaLabel: 'Générer mes rapports',
  },
  pilierLink: { label: 'Gestion trésorerie association', href: '/gestion-tresorerie-association' },
  sections: [
    {
      type: 'explain',
      title: 'Ce que doit contenir un rapport financier pour le CA',
      content: 'Les administrateurs d\'une association ne sont pas tous financiers. Votre rapport doit être :',
      items: [
        'Clair : solde actuel, évolution sur la période, comparaison budget',
        'Complet : encaissements, décaissements, état des subventions',
        'Actionnable : les points de vigilance clairement identifiés',
        'Synthétique : une page suffit pour l\'essentiel, les détails en annexe',
      ],
    },
    {
      type: 'checklist',
      title: 'Structure type d\'un rapport financier associatif',
      items: [
        'Solde de trésorerie au [date] : montant',
        'Évolution depuis le dernier CA : +/- montant',
        'Recettes de la période : total et détail (cotisations, subventions, ventes)',
        'Dépenses de la période : total et détail (personnel, fonctionnement, projets)',
        'État des subventions : attendues / reçues / en retard',
        'Prévision de trésorerie à 3 mois : alerte ou situation normale',
        'Points d\'attention : retards, anomalies, décisions à prendre',
      ],
    },
    {
      type: 'midcta',
      title: 'Finissez avec les 3 heures de consolidation avant chaque CA — générez votre rapport en 2 clics',
      content: 'Trezoone produit automatiquement vos rapports financiers associatifs, toujours à jour, en format PDF prêt à distribuer.',
    },
    {
      type: 'solution',
      title: 'Trezoone génère vos rapports automatiquement',
      content: 'Plus besoin de consolider manuellement avant chaque réunion. Trezoone produit le rapport en 2 clics.',
      items: [
        'Rapport de trésorerie mensuel généré automatiquement',
        'Mise en page professionnelle adaptée aux non-financiers',
        'Export PDF prêt à distribuer au CA',
        'Rapport d\'état des subventions inclus',
        'Comparaison budget prévisionnel / réalisé',
        'Indicateurs visuels clairs (vert/orange/rouge)',
      ],
    },
    {
      type: 'cluster',
      title: 'Outils pour les associations et structures aidées',
      links: [
        { label: 'Logiciel trésorerie association', href: '/logiciel-tresorerie-association' },
        { label: 'Trésorerie association loi 1901', href: '/tresorerie-association-loi-1901' },
        { label: 'Subvention en retard', href: '/subvention-en-retard-tresorerie' },
        { label: 'Simulation trésorerie association', href: '/simulation-tresorerie-association' },
        { label: 'Simulateur trésorerie association', href: '/simulateur-tresorerie-association' },
        { label: 'Excel trésorerie association', href: '/excel-tresorerie-association' },
        { label: 'Plan de trésorerie', href: '/plan-tresorerie' },
        { label: 'Alerte trésorerie', href: '/alerte-tresorerie' },
      ],
    },
    {
      type: 'cta',
      title: 'Vos rapports financiers, toujours prêts',
      content: 'Trezoone génère vos rapports de trésorerie en 2 clics. Essai gratuit 14 jours.',
    },
  ],
  relatedLinks: [
    { label: 'Logiciel trésorerie association', href: '/logiciel-tresorerie-association' },
    { label: 'Trésorerie association loi 1901', href: '/tresorerie-association-loi-1901' },
    { label: 'Subvention en retard', href: '/subvention-en-retard-tresorerie' },
    { label: 'Simulation trésorerie association', href: '/simulation-tresorerie-association' },
    { label: 'Excel trésorerie association', href: '/excel-tresorerie-association' },
    { label: 'Plan de trésorerie', href: '/plan-tresorerie' },
    { label: 'Alerte trésorerie', href: '/alerte-tresorerie' },
    { label: 'Prévision trésorerie', href: '/prevision-tresorerie' },
  ],
};

interface Props { onNavigate?: (p: string) => void; onSignIn?: () => void; onSignUp?: () => void; }
export default function ReportingFinancierAssociationPage({ onNavigate, onSignIn, onSignUp }: Props) {
  return <SeoLandingLayout data={data} onNavigate={onNavigate} onSignIn={onSignIn} onSignUp={onSignUp} />;
}
